import FakeUserApi from "./FakeUserApi";
import RealUserApi from "./RealUserApi";
import CommonRequestBodyDto from "../dto/common/CommonRequestBodyDto";
import UserTargetUpdateReqDto from "../dto/user/UserTargetUpdateReqDto";

class UserApi {
    fakeApi = false;
    fake = new FakeUserApi();
    real = new RealUserApi();

    getUserList = ({
        page,
        pageSize,
        enabled,
        search,
    }: {
        page: number;
        pageSize: number;
        enabled?: string;
        search?: string;
    }) => {
        if (this.fakeApi) {
            return this.fake.getUserList({ page, pageSize, enabled, search });
        } else {
            return this.real.getUserList({ page, pageSize, enabled, search });
        }
    };

    getUserInfo = () => {
        if (this.fakeApi) {
            return this.fake.getUserInfo();
        } else {
            return this.real.getUserInfo();
        }
    };

    updateTargetUserInfo = (reqDto: CommonRequestBodyDto<UserTargetUpdateReqDto>) => {
        if (this.fakeApi) {
            return this.fake.updateTargetUserInfo();
        } else {
            return this.real.updateTargetUserInfo(reqDto);
        }
    };

    putFranchiseUser({ franchise_join_status }: { franchise_join_status: string }) {
        return this.real.putFranchiseUser({ franchise_join_status });
    }
}

export default UserApi;
